import { render, staticRenderFns } from "./EditRuleField.vue?vue&type=template&id=21c57f94&scoped=true"
import script from "./EditRuleField.vue?vue&type=script&lang=js"
export * from "./EditRuleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c57f94",
  null
  
)

export default component.exports